import React from 'react'
import styles from './RadioGroup.scss'
import radioButtonTheme from './radioButtonTheme.scss'
import cx from 'classnames'
import PropTypes from 'prop-types'

export class Radio extends React.PureComponent {
  render () {
    const {optionKey, value, selected, theme, name, onChange, horizontal, className, ...props} = this.props

    const cn = cx(
      styles.label,
      theme.label,
      horizontal && styles.labelHorizontal,
      selected === optionKey && theme.selected,
      className
    )

    return (
      <label className={cn} key={optionKey} {...props}>
        <input
          name={name}
          className={cx(styles.radio, theme.radio)}
          type='radio'
          checked={selected === optionKey}
          onChange={onChange} />
        <span className={theme.labelText}>{value}</span>
        {this.props.children}
      </label>
    )
  }
}

export class RadioGroup extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    options: PropTypes.any.isRequired
  }

  static defaultProps = {
    theme: {}
  }

  render () {
    const {options, selected, theme, name, horizontal, onChange, radioClass, ...props} = this.props
    return (
      <div className={cx(styles.RadioGroup, theme.RadioGroup)} {...props}>
        {options.map((value, optionKey) => (
          <Radio
            key={optionKey}
            optionKey={optionKey}
            value={value}
            selected={selected}
            theme={theme}
            name={name}
            horizontal={horizontal}
            className={radioClass}
            onChange={() => onChange(optionKey)} />
        )).toIndexedSeq()}
      </div>
    )
  }
}

export const RadioButtonGroup = (props) => <RadioGroup theme={radioButtonTheme} {...props} />
